import { Badge } from '@/shared/ui';
import { Link } from '@tanstack/react-router';
import { ArrowLeft, Info } from 'lucide-react';

type PaymentSettingsExternalNoticeProps = {
  productCode: string;
  productName: string;
  /** Etiqueta da origem (ex.: "Configurado no Motor de Cálculo"). */
  label: string;
  description: string;
};

/**
 * O editor de um produto cujas formas de pagamento não são configuradas no
 * Portal: só o aviso de onde elas ficam, sem cobrança nem catálogo para editar.
 */
export function PaymentSettingsExternalNotice({
  productCode,
  productName,
  label,
  description,
}: PaymentSettingsExternalNoticeProps) {
  return (
    <div className='flex flex-col gap-4'>
      <Link
        to='/settings/products/payment-methods'
        className='flex w-fit items-center gap-1 text-sm text-alba-blue-500 hover:underline'
      >
        <ArrowLeft aria-hidden='true' className='h-4 w-4' />
        Formas de pagamento
      </Link>

      <div className='flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between'>
        <h2 className='text-lg font-semibold text-alba-black-500'>
          {productName}{' '}
          <span className='text-sm font-normal text-alba-gray-500'>
            · {productCode}
          </span>
        </h2>
        <Badge tone='gray'>{label}</Badge>
      </div>

      <div
        role='note'
        className='flex items-start gap-3 rounded-xl border border-alba-gray-200 bg-white p-4 text-sm text-alba-gray-700'
      >
        <Info
          aria-hidden='true'
          className='mt-0.5 h-5 w-5 shrink-0 text-alba-blue-500'
          strokeWidth={1.8}
        />
        <p>{description}</p>
      </div>
    </div>
  );
}
